import { render } from "./addDisease.vue?vue&type=template&id=0823169c&scoped=true"
import script from "./addDisease.vue?vue&type=script&lang=js"
export * from "./addDisease.vue?vue&type=script&lang=js"

import "./addDisease.vue?vue&type=style&index=0&id=0823169c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0823169c"]])

export default __exports__